import { HintMap } from '@/models/common/hint/hint-map.model';
import { StatisticsListHintNames } from '@/models/statistics/statistics-list-hint-names.model';

export const STATISTICS_LIST_HINT_MAP: HintMap = {
  [StatisticsListHintNames.TOTAL_GGR]: {
    title: 'Total GGR',
    description: 'casino GGR + betting GGR',
  },
  [StatisticsListHintNames.CASINO_GGR]: {
    title: 'Casino GGR',
    description: 'casino stakes - casino wins',
  },
  [StatisticsListHintNames.BETTING_GGR]: {
    title: 'Betting GGR',
    description: 'settled bet sum - settled bet win',
  },
  [StatisticsListHintNames.TOTAL_NGR]: {
    title: 'Total NGR',
    description: 'casino NGR + betting NGR',
  },
  [StatisticsListHintNames.CASINO_NGR]: {
    title: 'Casino NGR',
    description: 'casino stakes - casino wins - casino bonuses + correction withdraws - correction deposit',
  },
  [StatisticsListHintNames.BETTING_NGR]: {
    title: 'Betting NGR',
    description: 'settled bet sum - settled bet win - betting bonuses + correction withdraws - correction deposit',
  },
  [StatisticsListHintNames.TOTAL_RTP]: {
    title: 'Total RTP',
    description: 'casino wins + settled bet win / casino stakes + settled bet sum',
  },
  [StatisticsListHintNames.CASINO_RTP]: {
    title: 'Casino RTP',
    description: 'casino wins / casino stakes',
  },
  [StatisticsListHintNames.BETTING_RTP]: {
    title: 'Betting RTP',
    description: 'casino wins / casino stakes',
  },
};
